import { useTranslation } from "react-i18next";
import CommonCardUI from "./ui/Card/CommonCardUI";
import { Typography } from "@/components/ui";
import { error403Img } from "@/assets";

/**
 * Shared fallback for permission-guarded pages when the user lacks access.
 * Use with PermissionGuard: fallback={<UnauthorizedModuleFallback />}
 * so users see a consistent message on any page they can't access (e.g. direct URL or link).
 */
export const UnauthorizedModuleFallback = () => {
  const { t } = useTranslation(["common", "forbidden"]);
  return (
    <CommonCardUI
      className="bg-background border rounded-xl transition hover:shadow-lg w-full"
      classNameContent="p-8 flex justify-center flex-col items-center"
    >
      <img
        src={error403Img}
        alt="Permission denied"
        className="h-auto max-w-[25%]"
      />
      <Typography variant="h2" affects="bold" className="uppercase mb-2">
        {t("forbidden:TITLE")}
      </Typography>
      <Typography className="mb-1 mt-2 text-muted-foreground" variant="p">
        {t("forbidden:DESCRIPTION")}
      </Typography>
      <Typography className="text-muted-foreground pb-8" variant={"p"}>
        {t("forbidden:CONTACT_ADMIN")}
      </Typography>
    </CommonCardUI>
  );
};
